function ProjectsDashboard({ projects, onOpenProject }) {
  return (
    <div className="mx-auto max-w-6xl">
      <div className="mb-5">
        <h1 className="text-2xl font-bold">Projects</h1>
        <p className="mt-1 text-sm text-slate-600">Select an app to open it in the workspace.</p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {projects.map((project) => (
          <button
            key={project.key}
            type="button"
            onClick={() => onOpenProject(project.key)}
            className="group rounded-2xl border border-slate-200 bg-white p-4 text-left shadow-sm transition hover:-translate-y-0.5 hover:shadow-md"
          >
            <img src={project.logo} alt={project.name} className="mb-4 h-12 w-12 rounded-xl object-cover" />
            <h2 className="text-base font-bold text-slate-900">{project.name}</h2>
            <p className="mt-2 text-sm text-slate-600">{project.description}</p>
          </button>
        ))}
      </div>
    </div>
  );
}

export default ProjectsDashboard;
